import { useQueryClient } from "@tanstack/react-query";

import { hasValue } from "@core/foundation/types";

import { router } from "../../../bootstrap/router.ts";
import { authSelectors, authStore, useAuthStore } from "../state/auth.ts";
import { authSessionStore } from "../state/auth-session.ts";

interface LogoutResult {
  readonly isSignedIn: boolean;
  readonly logout: () => void;
}

export function useLogout(): LogoutResult {
  const queryClient = useQueryClient();

  const authToken = useAuthStore(authSelectors.authToken);

  return {
    isSignedIn: hasValue(authToken),
    logout: () => {
      authSessionStore.endSession();
      authStore.clearToken();
      queryClient.clear();
      window.location.replace(router.getUrl("Signin"));
    },
  };
}
